const scrollbarWidth = 4;
const scrollbarThumbColor = 'white';

export { scrollbarWidth, scrollbarThumbColor };
